<template lang="html">
  <div class="cw-order-list">
    <cw-order-cell
      v-for="order in orders"
      :boxSetInfo="order"
      :key="order._optimisticKey || order.workOrderId + order.tripType"
      @click="selectionHandler(order)"
    ></cw-order-cell>
  </div>
</template>

<script>
export default {
  name: 'cw-order-list',
  props: {
    orders: {
      type: Array,
      required: true,
    },
    selectionHandler: {
      type: Function,
      required: false,
      default: () => {},
    },
  },
};
</script>

<style lang="" scoped></style>
